var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#D1F178"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2617_9560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5728 65.0001C34.5813 65.0001 33.6065 64.7002 32.7733 64.117C32.3401 63.817 31.9569 63.4505 31.6402 63.0255L25.2499 54.494C24.8333 53.9441 24.95 53.1609 25.4999 52.7444C26.0497 52.3278 26.8329 52.4444 27.2495 52.9943L33.6482 61.5259C33.8065 61.7341 33.9898 61.9174 34.2064 62.0674C34.7396 62.434 35.3811 62.5756 36.0143 62.4673C36.6475 62.3507 37.2058 62.0008 37.5723 61.4675L62.7171 25.5334C63.1087 24.9668 63.8919 24.8335 64.4584 25.2251C65.025 25.625 65.1583 26.3998 64.7667 26.9664L39.6219 62.8922C38.8721 63.967 37.7473 64.6919 36.4559 64.9168C36.1643 64.9668 35.8727 64.9918 35.5811 64.9918L35.5728 65.0001Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2617_9560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.9917,
    height: 40,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupIcon);
export default __webpack_public_path__ + "static/media/popup_icon.4886a4829ca01b9672d3a15738b0be80.svg";
export { ForwardRef as ReactComponent };